import React   from 'react';
import Show from "./show";
import OntologyHelper from "./ontology_helper";

class ViewMulti extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			linked: null,
			ontology: new OntologyHelper(null)
		};

		const view  = this.props.view;
		this.linked = [];

		if (view.views !== undefined) {
			for (let i = 0; i < view.views.length; i++) {
				const l = view.views[i].view;
				if (l !== null && l !== undefined) {
					this.linked.push(l);
				}
			}
		}
	}

	componentDidMount() {
		let linked = [];
		const filter = this.props.filter;
		this.linked.map((l, i) => {
			this.props.model
				.getLinkedView(l)
				.then(response => {
					linked[i] = {view: response.view, filter: null};
					if (filter !== null) {
						linked[i].filter = {
							field: this.props.model.getLinkedColumnByViewId(response.view.id, filter.field),
							value: filter.value
						}
					}
					this.setState({
						linked: linked,
					});
				});
		});
	}

	render() {
		const ontology = this.state.ontology;
		return this.state.linked !== null && (
			<div className='multi'>
				{this.state.linked.map((linked) => (
					<div key={linked.view.id} className='view-item'>
						<h1>{ontology.getViewTitle(linked.view)}</h1>
						<Show
							model  = {this.props.model}
							view   = {linked.view}
							filter = {linked.filter}
						/>
					</div>
				))}
			</div>
		);
	}

}

export default ViewMulti;
